// extracted by mini-css-extract-plugin
export default {"wrap":"rG-z","fullWidth":"sG-z","hideOnDesktop":"tG-z","content":"uG-z","hasOpenedNav":"vG-z","crumbsList":"wG-z","dropdownsWrap":"xG-z"};